import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export { cn as mergeClasses };

export * from './components/button';
export * from './components/input';
export * from './components/label';
export * from './components/card';
export * from './components/badge';
export * from './components/spinner';
export * from './components/page-layout';
export * from './components/metric-block';
export * from './components/data-table';
export * from './components/code-block';
export * from './components/navigation';
export * from './components/overlay';
